// Maps abbreviated team names to their official names
export const ABBREVIATED_TO_OFFICIAL: Record<string, string> = {
    "FAU": "Florida Atlantic",
    "San Diego St.": "San Diego State",
    "Morehead St.": "Morehead State",
    "Wash. St.": "Washington State",
    "N. Carolina": "North Carolina",
    "Miss. St.": "Mississippi State",
    "Michigan St.": "Michigan State",
    "Iowa St.": "Iowa State",
    "S. Dak. St.": "South Dakota State",
    "Utah St": "Utah State",
    "Colorado St": "Colorado State",
    "Grambling St": "Grambling",
    "LBSU": "Long Beach State"
}; 